import { getRouteApi, useNavigate } from '@tanstack/react-router'
import { useAuthHook } from '../utils/hooks/auth.hooks'
import { useFetchCustomTheme } from '../pages/settings-customHook'
import { SecondaryButton } from './secondary-button'
import { queryClient } from '../context/constants'
import { CustomHelmet } from './CustomHelmet'
const router1 = getRouteApi('/$clientid/_app')
export const CustomerInactive = () => {
    const navigate = useNavigate()
    const params = router1.useParams()
    const { data: userData } = useAuthHook()
    const { data: themeConfig } = useFetchCustomTheme()
    return (
        <div className="flex flex-1 flex-col items-center justify-center w-full space-y-2">
            <CustomHelmet />
            <img
                src="/svg/401.svg"
                alt=""
                className="w-[500px] h-auto max-md:w-[50%]"
            />
            <div className="max-md:max-w-[100%] text-center">
                <p
                    className="text-xl max-md:text-sm max-md:whitespace-normal"
                    style={{ color: themeConfig?.visibleTextColor }}
                >
                    Your request could not be processed as Customer{' '}
                    <span className="underline">
                        {userData?.userDetails.Customer}
                    </span>{' '}
                    is inactive.
                </p>
                <p
                    className="text-xl max-md:text-sm max-md:whitespace-normal"
                    style={{ color: themeConfig?.visibleTextColor }}
                >
                    Please contact admin for support.
                </p>
            </div>
            {userData?.refreshToken && (
                <SecondaryButton
                    onClick={() => {
                        localStorage.clear()
                        queryClient.invalidateQueries()
                        navigate({
                            to: '/$clientid',
                            params,
                        })
                    }}
                >
                    Logout
                </SecondaryButton>
            )}
        </div>
    )
}
